import { jwtDecode } from "jwt-decode";

/**
 * Extracts userType and userId from JWT token
 * @param {string} token - JWT Access Token
 * @returns {{ userType: string|null, userId: string|null }}
 */
export function getUserInfoFromToken() {
  const token = localStorage.getItem("access_token");
  if (!token) return { userType: null, userId: null };

  try {
    const decoded = jwtDecode(token);

    const rawUserId = decoded.user_id ?? decoded.id ?? null;
    return {
      userType: decoded.user_type || decoded.role || null,
      userId: rawUserId != null ? String(rawUserId) : null,
    };
  } catch (error) {
    console.error("Invalid token:", error);
    return { userType: null, userId: null };
  }
}
